import { useEffect } from 'react'
import { createToaster, Toast, Toaster } from '@ark-ui/react'
import { SnackbarSeverityType } from '@/AppContext'
import { Alert } from '@/UIComponents2/Alert'
import CrossIcon from '@/CustomIcons/CrossIcon'
import { ChatboxSnackbarInfo } from '../ChatRoom'

const toaster = createToaster({
    placement: 'top',
    overlap: false,
    gap: 8,
})

export default function ChatRoomSnackbar({ data }: { data: ChatboxSnackbarInfo | null }) {
    const convertSeverityToLevel = (severity: SnackbarSeverityType) => {
        switch (severity) {
            case 'success':
                return 'success'
            case 'info':
                return 'success'
            case 'error':
                return 'danger'
            case 'warning':
                return 'warning'
        }
        return 'success'
    }

    useEffect(() => {
        if (data) {
            toaster.create({
                title: data.message,
                type: data.severity || 'info',
                duration: 3000, // data.duration || 3000,
            })
        }
    }, [data])

    return (
        <div style={{ zIndex: 20 }}>
            <Toaster toaster={toaster}>
                {(toast) => (
                    <Toast.Root className="w-full" key={toast.id}>
                        <div className="flex justify-center w-full h-0 overflow-visible">
                            <div className="h-full">
                                <Alert
                                    className="w-[90vw] md:max-w-lg w-fit"
                                    contentClassName="w-full flex items-center justify-between gap-2"
                                    variant="solid"
                                    level={convertSeverityToLevel(toast.type as any)}
                                >
                                    {toast.title}
                                    <Toast.CloseTrigger>
                                        <div className="cursor-pointer">
                                            <CrossIcon color="black" />
                                        </div>
                                    </Toast.CloseTrigger>
                                </Alert>
                            </div>
                        </div>
                    </Toast.Root>
                )}
            </Toaster>
        </div>
    )
}

{
    /* TODO: add snackbar */
}
{
    /* {chatboxSnackbar && (
    <Snackbar
        className="absolute! top-2! left-0! transform-none! mx-2"
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={true}
        autoHideDuration={5000}
        onClose={() => set_chatboxSnackbar(null)}
    >
        <Alert onClose={() => set_chatboxSnackbar(null)} severity={chatboxSnackbar.severity}>
            {chatboxSnackbar.message}
        </Alert>
    </Snackbar>
)} */
}
